/**
 * @generated SignedSource<<30996e76525e5b240c9e84332977d7c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LoginTypeFilter_orgIdps$data = {
  readonly identityProviderConfigurations: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
        readonly uuid: string;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "LoginTypeFilter_orgIdps";
};
export type LoginTypeFilter_orgIdps$key = {
  readonly " $data"?: LoginTypeFilter_orgIdps$data;
  readonly " $fragmentSpreads": FragmentRefs<"LoginTypeFilter_orgIdps">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LoginTypeFilter_orgIdps",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IdentityProviderConfigurationConnection",
      "kind": "LinkedField",
      "name": "identityProviderConfigurations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "IdentityProviderConfigurationEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IdentityProviderConfiguration",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "ddffc297375b2031e0205b8059b8067f";

export default node;
